import { Component, OnInit } from '@angular/core';
import { BsModalRef } from 'ngx-bootstrap/modal';
import { ToastrService } from 'ngx-toastr';
import { ConstantsService } from 'src/app/shared/services/Constants/constants.service';
import { DataContextService } from 'src/app/shared/services/data-context.service';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { AuditData } from 'src/app/shared/classes/AuditTrail';
import { OutwardStatus } from 'src/app/Enums/outwardEnum';
import { TrackerOmnitureService } from 'src/app/shared/services/tracker-omniture.service';

@Component({
  selector: 'app-l2approver-comments',
  templateUrl: './l2approver-comments.component.html',
  styleUrls: ['./l2approver-comments.component.css']
})
export class L2approverCommentsComponent implements OnInit {

  private unsubscribe$ = new Subject<void>();
  
  service_URL: any;
  count : number = 0;
  reason : string = '';
  selectedRequest: any;
  flag: boolean = true;
  emailId: string ='';

  constructor(public modalRef: BsModalRef, private toast: ToastrService,private trackeromnitureservice:TrackerOmnitureService, private _dataContextService: DataContextService,
    ) { 
      this.service_URL = ConstantsService;
    }

  ngOnInit(): void {

    this.emailId=localStorage.getItem('email');

    var username = localStorage.getItem('email');
    username = username.split('@')[0];
    this.trackeromnitureservice.trackPageloadData('ourtward-l2approver',username);
    this.trackeromnitureservice.trackPage("pageView");
  }

  showcount(reason : any){
    this.count = this.reason.length;
    if(this.reason !== '' && this.count > 0){
      this.flag = false;
    }
    else{
      this.flag = true;
    }
  }

  onReject() {
    let previousStatusId;
    
    switch (this.selectedRequest.status) {
      case 'Created':
        previousStatusId = OutwardStatus.Created;
        break;
      case 'LA approved 1':
        previousStatusId = OutwardStatus.LAapprover1; 
        break;
      case 'LA Approved 2':
        previousStatusId = OutwardStatus.LAapprover2; 
        break;
      case 'Supervisor Approved':
        previousStatusId = OutwardStatus.Supervisor; 
      case 'Print Pass':
        previousStatusId = OutwardStatus.PrintPass; 
        break;
      case 'Received':
        previousStatusId = OutwardStatus.Received; 
        break;
      default:
        previousStatusId = OutwardStatus.Created;
    }
  
    let params = {
      statusId: OutwardStatus.Declined,
      previousStatusId: previousStatusId,
      requestId: this.selectedRequest.requestId,
      DeclinedByNotes: this.reason,
      Updatedby: this.emailId
    };
  
    let auditData = [];
  
    let statusChangeAudit: AuditData = new AuditData();
    statusChangeAudit.changedAttribute = "Status";
    statusChangeAudit.oldValue = this.selectedRequest.status;
    statusChangeAudit.newValue = "Declined";
  
    auditData.push(statusChangeAudit);
  
    this._dataContextService.postDatawithValues<any>(this.service_URL.OutwardDetails.UpdateStatus, params)
      .pipe(takeUntil(this.unsubscribe$))
      .subscribe((res) => {
        if (res == 1) {
          this.toast.success("Request Rejected");
          
          // Saving Data in Audit Trail - only on success
          let auditParams = {
            actionPerformed: "Status Change",
            actionPerformedOn: "Outward",
            changedBy: localStorage.getItem('email'),
            dateChanged: new Date(),
            primaryKey: this.selectedRequest.serialNumber,
            generalInformation: [],
            material: [],
            statusChange: auditData
          };

          console.log('Calling audit trail API:', this.service_URL.AuditTrail.savetransactionaudittrail);
          console.log('Audit trail params:', auditParams);

          this._dataContextService.postDatawithValues<any>(this.service_URL.AuditTrail.savetransactionaudittrail, auditParams)
            .pipe(takeUntil(this.unsubscribe$))
            .subscribe(
              (auditRes) => {
                console.log('Audit trail saved successfully:', auditRes);
              },
              (auditErr) => {
                console.error('Error saving audit trail:', auditErr);
                this.toast.warning('Rejection saved but audit trail failed');
              },
              () => {
                this.modalRef.hide();
                // Delay reload to ensure audit trail completes
                setTimeout(() => {
                  window.location.reload();
                }, 500);
              }
            );
        } else {
          this.toast.error("Something went wrong");
        }
      },
      (err) => {
        console.error('Error updating status:', err);
        this.toast.error("Something went wrong");
      });
  }

}
